/** getImage Strategy:
 *  1. image_url
 *  2. generated_image_urls.url
 *  3. defeault Image based on islandType
 */
export const getImage = (data, defaultImg, defaultImg2) => {
  if (!data) {
    return defaultImg2;
  }
  const {islandType, image_url, generated_image_urls} = data;
  if (image_url) return image_url;
  if (generated_image_urls && generated_image_urls.url) return generated_image_urls.url;

  switch (islandType) {
    case 'CreativePlot:temperate_medium':
      return defaultImg2;
    case 'CreativePlot:theblock_season7':
      return defaultImg;
    default:
      return defaultImg2;
  }
};

export const capitalizeText = (text) =>
  (text || '').replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));

interface Params {
  [key: string]: string | undefined;
}

export const populateTemplate = (message: string, params: Params): string => {
  return capitalizeText(
    Object.keys(params).reduce((msg, param) => {
      // eslint-disable-next-line no-useless-escape
      const reg = new RegExp(`\{${param}\}`);
      return msg.replace(reg, params[param] || '');
    }, message)
  );
};
